<script setup>
import {computed, onMounted, ref, watch} from "vue";
import SquareIconButton from "@/components/global-themed/buttons/SquareIconButton.vue";
import useAutoResize from "@/composables/useAutoResize";
import {useStore} from "vuex";

const localValue = ref('');
const success = ref(false);

const props = defineProps({
  value: {
    required: true,
    type: String,
  },
  label: {
    required: true,
    type: String,
  },
});

// we don't need to keep the parent updated with the changes
watch(
  () => props.value,
  (newValue) => {
    localValue.value = newValue;
  },
  {immediate: true}
);

// only works via https
const handleCopy = () => {
  navigator.clipboard.writeText(localValue.value)
    .then(() => {
      success.value = true;
      setTimeout(() => {
        success.value = false;
      }, 3000);
    }).catch(() => {
    console.error("Failed to copy to clipboard");
  });
}

const {textareaRef, autoResize} = useAutoResize();

onMounted(() => autoResize());

const store = useStore();
const activeTab = computed(() => store.getters['actions/contentWizardActiveTab']);

watch(activeTab, autoResize)
</script>

<template>
  <div class="tw-p-8 tw-border tw-rounded-lg tw-border-grey-mid tw-flex tw-flex-col tw-gap-4">
    <label class="tw-font-bold tw-text-grey-dark tw-text-2xl">
      {{ label }}
    </label>
    <div class="tw-flex tw-justify-between tw-items-center tw-w-full tw-gap-4">
      <textarea
        ref="textareaRef"
        v-model="localValue"
        class="tw-overflow-hidden tw-border-2 tw-border-grey-mid tw-flex tw-text-black tw-self-stretch focus-within:tw-border-blue tw-rounded-lg tw-px-6 tw-py-3 tw-text-lg tw-w-full tw-resize-none"
        rows="1"
        @input="autoResize"
      />
      <SquareIconButton
        class="!tw-h-13 tw-transition-colors tw-duration-200"
        :class="{
          '!tw-bg-everest-bright': success,
        }"
        @click="handleCopy"
      >
        <svg-vue
          :icon="success ? 'icons/tick-thin' : 'icons/copy-folders'"
          class="tw-w-6 tw-text-white"
        />
      </SquareIconButton>
    </div>
  </div>
</template>
